import React from "react";
import { BaseFilterProps } from "../../lib";
import { OrgTaskTemplateOptionsFilter } from "./OrgTaskTemplateOptionsFilter";
import {
    isTaskTypeValue,
    ORG_TASK_TEMPLATE_TYPE_OPTIONS,
} from "./orgTaskTemplateFilterOptions";

export const OrgTaskTemplateTypeFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <OrgTaskTemplateOptionsFilter
        options={ORG_TASK_TEMPLATE_TYPE_OPTIONS}
        selected={filters.orgTaskTemplateTypes}
        isOptionValue={isTaskTypeValue}
        onChange={(orgTaskTemplateTypes) => onChange({ orgTaskTemplateTypes })}
        name="orgTaskTemplateTypes"
    />
);
